import React, { useContext } from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { BuildingConstruction } from '../../../../../../../services/types/Calculator';
import CalculatorSectorContext from '../../UrbanInfrastructureTool/CalculatorSectorContext';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  buildingConstruction: BuildingConstruction;
}

const BuildingConstructionDetails: React.FC<Props> = ({ buildingConstruction }) => {
  const { t } = useTranslation();

  const { measurementSystem } = useContext(CalculatorSectorContext);

  const getTextMeasure = (): string =>
    measurementSystem.id === 1 ? '(sq meters)' : '(square feet)';

  const getTextEmissionMetric = (): string =>
    measurementSystem.id === 1 ? '(kg CO<sub>2</sub>/sq meters)' : '(lbs CO<sub>2</sub>/sq ft)';

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '18%' }} />
          <col style={{ width: '28%' }} />
          <col style={{ width: '34%' }} />
          <col style={{ width: '20%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('Buildings Materials')}</th>
            <th>{parse(t('Default Emissions Factor ') + getTextEmissionMetric())}</th>
            <th>{t('Default Total Area of Materials in Buildings ') + getTextMeasure()}</th>
            <th>{parse(t('CO<sub>2</sub> Emissions (t CO<sub>2</sub>)'))}</th>
          </tr>
        </thead>
        <tbody>
          {buildingConstruction.subTotal && (
            <>
              <tr>
                <td>{buildingConstruction.columns.name}</td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.columns.defaultFactor} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.columns.defaultArea} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.columns.emissions} />
                </td>
              </tr>
              <tr>
                <td>{buildingConstruction.floors.name}</td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.floors.defaultFactor} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.floors.defaultArea} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.floors.emissions} />
                </td>
              </tr>
              <tr>
                <td>{buildingConstruction.exteriorWalls.name}</td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.exteriorWalls.defaultFactor}
                  />
                </td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.exteriorWalls.defaultArea}
                  />
                </td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.exteriorWalls.emissions}
                  />
                </td>
              </tr>
              <tr>
                <td>{buildingConstruction.windows.name}</td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.windows.defaultFactor} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.windows.defaultArea} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.windows.emissions} />
                </td>
              </tr>
              <tr>
                <td>{buildingConstruction.interiorWalls.name}</td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.interiorWalls.defaultFactor}
                  />
                </td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.interiorWalls.defaultArea}
                  />
                </td>
                <td>
                  <NumberFormatterSinSeparador
                    value={buildingConstruction.interiorWalls.emissions}
                  />
                </td>
              </tr>
              <tr>
                <td>{buildingConstruction.roofs.name}</td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.roofs.defaultFactor} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.roofs.defaultArea} />
                </td>
                <td>
                  <NumberFormatterSinSeparador value={buildingConstruction.roofs.emissions} />
                </td>
              </tr>
            </>
          )}
        </tbody>
        <tfoot>
          <tr>
            {/* espaciador intencional, sin contenido */}
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td colSpan={4} />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default BuildingConstructionDetails;
